import { isNil } from '#packages/data-collection/libs/lodash';

export const parseIntOrUndefined = (value?: string) =>
  isNil(value) ? undefined : parseInt(value);
